import {
  THEME_SETTING_API,
  THEME_SETTING_API_SEARCH,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  SearchThemeSettingRequestModel,
  ThemeSettingModel,
} from "./theme-setting.models";

export const searchThemeSettingApi = async (
  searchThemeSettingPageRequestModel: SearchThemeSettingRequestModel,
  langCode?: string
) => {
  const createResponse = await apiClient.postHttp<
    PagedResult<ThemeSettingModel>
  >(`${THEME_SETTING_API_SEARCH}`, searchThemeSettingPageRequestModel, {
    params: { langCode },
  });
  return createResponse;
};

export const removeThemeSettingApi = async (
  removedModel: RemovedEntityModel<string>
) => {
  const response = await apiClient.postHttp(
    `${THEME_SETTING_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getThemeSettingByIdApi = async (id: string, langCode?: string) => {
  return await apiClient.getHttp<ThemeSettingModel>(
    `${THEME_SETTING_API}/${id}`,
    { params: { langCode } }
  );
};

export const getThemeSettingListApi = async (langCode?: string) => {
  return await apiClient.getHttp<ThemeSettingModel[]>(`${THEME_SETTING_API}`, {
    params: { langCode },
  });
};

export const addThemeSettingApi = async (
  model: ThemeSettingModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<string>(
    `${THEME_SETTING_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const updateThemeSettingApi = async (
  model: ThemeSettingModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp(`${THEME_SETTING_API}`, model, {
    params: { langCode },
  });
  return response;
};

export const getGlobalThemeSettingApi = async () => {
  const response = await apiClient.getHttp<ThemeSettingModel>(
    `/api/v1/client/themes/global`,
    undefined,
    false
  );
  return response;
};
